import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=55c75ad2&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=55c75ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c75ad2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OptimizedImage: require('/app/components/ui/OptimizedImage.vue').default})
